module.exports = __webpack_public_path__ + "img/diaohua1.4c99064a.jpg";